import React from 'react';
import { BoundSelect } from "../BoundSelect";
import { BookingDurationType } from "../../../../constants/securspace-constants";

type BoundDurationTypeSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundDurationTypeSelect = <T,>({
  label = "Duration Type",
  name,
  value = '',
  onChange
}: BoundDurationTypeSelectProps<T>) => {

  return <BoundSelect<T>
    options={BookingDurationType}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundDurationTypeSelect };